import type { FC } from "react";
import { useState } from "react";
import styled from "styled-components";
import "@nectary/components/popover";
import { logout } from "../../auth";
import { useProfileContext } from "../../portals/messagemedia/providers";
import {
  ItemContainer,
  ItemButtonContainer,
} from "../NavigationBar/SidebarItemElements";
import { useSidebarState } from "../NavigationBar/state";
import { ProfileAvatarNavItem } from "./ProfileAvatar";
import { ProfileContent } from "./ProfileContent";

export const ProfileItemContainer = styled.div`
  display: inline-flex;
  flex: 1;
  position: absolute;
  background: white;
  overflow: hidden;
  bottom: 0;
  right: 0;
  left: 0;
`;

export const ProfilePopupWrapper = styled.div`
  width: 211px;
  padding: 8px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
`;

export const ProfileItem: FC = () => {
  const [isOpen, setOpen] = useState(false);
  const { name } = useProfileContext();
  const { isCollapsed } = useSidebarState();
  const onOpen = () => setOpen(true);
  const onClose = () => setOpen(false);

  return (
    <sinch-popover
      aria-label="Popover"
      open={isOpen}
      modal
      orientation="top-right"
      on-close={onClose}
    >
      <ItemContainer isCollapsed={isCollapsed} isFlex slot="target">
        <ItemButtonContainer isActive={false}>
          <ProfileAvatarNavItem name={name} onClick={onOpen} />
        </ItemButtonContainer>
      </ItemContainer>
      <ProfilePopupWrapper slot="content">
        <ProfileContent onClose={onClose} logout={() => logout()} />
      </ProfilePopupWrapper>
    </sinch-popover>
  );
};
